import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import type { ButtonElement } from '../../types';

export const BUTTON_ELEMENTS: HTMLSerializeOptions['elements'] = {
    button: (node: ButtonElement) => {
        const fullWidthClass = node.fullWidth ? ' lumx-button--is-full-width' : '';
        const style = [
            node.backgroundColor &&
                `--lumx-button-emphasis-high-state-default-theme-light-background-color:${escapeHTML(
                    node.backgroundColor,
                )}`,
            node.color && `--lumx-button-emphasis-high-state-default-theme-light-color:${escapeHTML(node.color)}`,
        ]
            .filter(Boolean)
            .join(';');
        const styleAttr = style ? ` style="${style}"` : '';

        return `<div class="wrex-content-button"><a class="lumx-button${fullWidthClass}" href="${escapeHTML(
            node.href || '',
        )}"${styleAttr}>${escapeHTML(node.label || '')}</a></div>`;
    },
};
